import React from "react";
import { ShieldCheck, ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const COPY = {
  trial: {
    body: "Sometimes a business decision needs more than intelligence alone. Get practical guidance and follow-up from the C-ORE team on the decisions that matter to your business.",
  },
  pulse: {
    body: "Sometimes a business decision needs more than intelligence alone. Get practical guidance and follow-up from the C-ORE team on the decisions that matter to your business.",
  },
};

export default function ExpertLocked({ reason }) {
  const navigate = useNavigate();
  const copy = COPY[reason] || COPY.pulse;
  return (
    <div data-testid="expert-locked-state" className="max-w-2xl border border-slate-200 rounded-2xl bg-white p-8 md:p-10">
      <div className="w-11 h-11 rounded-full bg-[#F0F5FF] flex items-center justify-center">
        <ShieldCheck className="w-5 h-5 text-[#1E3A5F]" />
      </div>
      <p className="mt-5 text-[15px] leading-relaxed text-slate-600 max-w-xl">{copy.body}</p>
      <p className="mt-4 text-[13px] font-semibold text-slate-500">
        Available with C-ORE Command and Sovereign.
      </p>
      <button
        data-testid="expert-upgrade-cta"
        onClick={() => navigate("/pricing")}
        className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#1E3A5F] text-white px-6 py-3 text-[13px] font-semibold hover:opacity-90 transition"
      >
        Upgrade to unlock <ArrowUpRight className="w-4 h-4" />
      </button>
    </div>
  );
}
